import React, { useEffect, useState } from "react";
import { Alert, Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { confirmEmailVerification } from "../api/auth";
import AuthShell from "../components/auth/AuthShell";

function VerifyEmailPage() {
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");
  const [loading, setLoading] = useState(Boolean(token));
  const [statusMessage, setStatusMessage] = useState(token ? "Verifying your email..." : "This verification link is missing or invalid.");
  const [statusSeverity, setStatusSeverity] = useState(token ? "info" : "error");

  useEffect(() => {
    let mounted = true;
    async function verify() {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        await confirmEmailVerification(token);
        if (!mounted) return;
        setStatusMessage("Email verified. You can return to TrustBud.");
        setStatusSeverity("success");
      } catch (error) {
        if (!mounted) return;
        setStatusMessage(error.message || "This verification link is invalid or expired.");
        setStatusSeverity("error");
      } finally {
        if (mounted) setLoading(false);
      }
    }
    verify();
    return () => {
      mounted = false;
    };
  }, [token]);

  return (
    <AuthShell
      heroBadge="Account security"
      heroTitle="Verify your email."
      heroBody="This keeps account recovery and accountability messages pointed at the right inbox."
      eyebrow="Email verification"
      title="Confirming your email."
      body="This should only take a moment."
      maxWidth={980}
      reverseOnDesktop
    >
      <Stack spacing={2}>
        <Alert severity={statusSeverity} sx={{ borderRadius: 3 }}>
          {loading ? <CircularProgress size={16} sx={{ mr: 1 }} /> : null}
          {statusMessage}
        </Alert>
        <Box>
          <Button component={RouterLink} to="/login" variant="contained" sx={{ borderRadius: 999, textTransform: "none", fontWeight: 700 }}>
            Open TrustBud
          </Button>
        </Box>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          If this was not you, you can ignore the email.
        </Typography>
      </Stack>
    </AuthShell>
  );
}

export default VerifyEmailPage;
